import clsx from 'clsx';
import type { ComponentPropsWithoutRef } from 'react';

import styles from './ActionRow.module.scss';

type ActionRowProps = ComponentPropsWithoutRef<'div'> & {
    align?: 'start' | 'center' | 'end';
    wrap?: boolean;
};

export const ActionRow = ({ align = 'start', className, wrap = true, ...props }: ActionRowProps) => (
    <div className={clsx(styles.actionRow, wrap ? styles.wrap : styles.nowrap, styles[align], className)} {...props} />
);
